import type { ParsedUrlQuery } from 'node:querystring';

export const parseUrl = (query: ParsedUrlQuery) =>
    new URLSearchParams(
        Object.entries(query)
            .filter((entry): entry is [string, string | string[]] => typeof entry[1] === 'string' || Array.isArray(entry[1]))
            .flatMap(([key, value]) => (Array.isArray(value) ? value.map((v) => [key, v]) : [[key, value]])),
    );
